<template>
  <div class="containerBox">
    <!-- 轮播 -->
    <el-carousel height="470px">
      <el-carousel-item v-for="(item, index) in swiperList" :key="index">
        <div>
          <img
            :src="item.src"
            alt="banner"
            style="width: 100%; height: 100%; vertical-align: bottom;"
          />
        </div>
      </el-carousel-item>
    </el-carousel>
    <!-- 第二部分 -->
    <div class="companyIntro">
      <div class="comImg">
        <img
          src="https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/174711769985370.png"
          alt="公司图片"
          style="width: 100%; vertical-align: baseline"
        />
      </div>
      <div class="comText">
        <div style="margin-bottom: 30px">
          <div class="comtitle">
            <strong>关于品谱</strong>
          </div>
          <span style="font-size: 35px; color: #ccc">About Us</span>
        </div>
        <p class="comContain">
          品谱集团总部位于美国威斯康辛州麦迪逊，是财富美国500强企业，同时也是纽约证券交易所上市公司。<br />
          作为年销售额超过50亿美元全球性消费品公司，品谱集团旗下有德彩，富美内特，天然奇迹，洁齿骨零
          食等多个全球领先的水族用品及宠物用品品牌，持续为为全球消费者和客户创造卓越价值。
        </p>
        <button class="moreBtn" @click="openMore">
          <span>了解更多</span>
          <i class="el-icon-arrow-right"></i>
        </button>
      </div>
    </div>

    <!-- 第三部分 子产品介绍 -->
    <div class="sonBrandContainer">
      <div class="sonBrandBox">
        <div class="title">
          <div class="comtitle">
            <strong>旗下品牌</strong>
          </div>
          <span style="font-size: 35px; color: #ccc">Our Brands</span>
        </div>

        <div class="sonBrandBoxItem">
          <div class="sonBrand" v-for="(item, index) in sonBrands" :key="index" @click="openDetail(item)">
            <div
              :style="{ backgroundImage: 'url(' + item.url + ')' }"
              class="sonBrandImg"
            ></div>
            <div class="BrandDesc">
              <span class="descTitle">{{ item.title }}</span>
              <span class="desc">{{ item.desc }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部栏 -->
    <foot></foot>
  </div>
</template>

<script>
import foot from "@/components/footer.vue";
export default {
  data() {
    return {
      swiperList: [{
        id:1,
        src: "https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/174711755095410.jpg"
      },{
        id:2,
        src: "https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/174711757626432.jpg"
      },{
        id:3,
        src: "https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/174711758786596.jpg"
      },
    ],
      sonBrands: [
        {
          url:"https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/174711800754960.png",
          title: "Tera德彩",
          desc: "享誉全球超过七十年的德国优质水族品牌",
          website: "/AboutTetra",
        },
        {
          url: "https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/1747118031148139.png",
          title: "Smartbones",
          desc: "洁齿骨犬类零食品牌",
          website: "/AboutSmartBone/About",
        },
        {
          url: "https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/1747118060274146.png",
          title: "富美内特",
          desc: "全面的宠物被毛护理品牌",
          website: "/AboutFurminator",
        },
        {
          url: "https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/1747118084597148.png",
          title: "天然奇迹",
          desc: "宠物消毒/清洁/祛污/除臭品牌",
          website: "/AboutNatureMiracle",
        },
      ],
    };
  },
  components: {
    foot,
  },
  methods: {
    openMore() {
      this.$router.push("/BrandDescription");
    },
    openDetail(item) {
      this.$router.push(item.website)
    },
  },
};
</script>

<style scoped lang="scss">
.containerBox {
  .companyIntro {
    width: 1200px;
    margin: 90px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .comImg {
      width: 600px;
      height: 600px;
      margin-right: 40px;
    }
    .comText {
      display: flex;
      flex-direction: column;
      .comtitle {
        font-size: 46px;
        color: #333;
      }
      .comContain {
        width: 540px;
        margin: 40px 0;
        padding: 0;
        font-size: 20px;
        color: #666;
        line-height: 1.75em;
      }
    }
    .moreBtn {
      width: 185px;
      height: 60px;
      margin-top: 40px;
      outline: none;
      display: flex;
      justify-content: center;
      align-items: center;
      border: none;
      border-radius: 4px;
      text-align: center;
      background-color: #2e6ab0;
      span {
        line-height: 60px;
        font-size: 18px;
        margin-right: 4px;
        color: #fff;
      }
      i {
        line-height: 60px;
        color: #fff;
        font-size: 20px;
      }
    }
    .moreBtn:hover {
      background-color: #3576c0;
      cursor: pointer;
    }
  }

  .sonBrandContainer {
    background: #f4f7fb;
    padding: 120px 0 80px;
    .sonBrandBox {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      .title {
        margin-bottom: 40px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .comtitle {
          font-size: 46px;
          color: #333;
        }
      }
      .sonBrandBoxItem {
        width: 1200px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .sonBrand {
          width: 580px;
          .sonBrandImg {
            width: 580px;
            height: 435px;
            // background-image: url("../assets/sonBrand01.png");
          }
          .sonBrandImg:hover {
            background-size: 580px 435px;
            background-repeat: no-repeat;
            animation: fd 1.5s;
          }

          @keyframes fd {
            from {
              background-size: 580px 435px;
            }
            to {
              background-size: 650px 487px;
            }
          }
        }
        .BrandDesc {
          width: 580px;
          height: 100px;
          background-color: #fff;
          margin-bottom: 40px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.08);
          .descTitle {
            font-size: 30px;
            color: #333;
            font-weight: 600;
          }
          .desc {
            margin-top: 5px;
            font-size: 20px;
            color: #666;
          }
        }

        .BrandDesc:hover {
          background-color: #2e6ab0;
          span {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
